// Testimonial data shape + seed quotes.
//
// Phase A (current): seed quotes live in this file. Swap `useTestimonials`
// to read from Firestore when Phase B lands — the shape is identical.
//
// Each testimonial:
//   id         — stable key for rendering
//   text       — the quote itself
//   authorName — person credited (first name + last initial for privacy)
//   context    — what event / where they encountered it
//   tier       — "press" | "booker" | "guest" (optional, used for weighting later)
//   createdAt  — ISO date-ish string (sort order in the marquee)
//
// Keep quotes punchy — a marquee card has ~3 lines of breathing room before
// it feels crowded. Cut to the line that makes someone stop scrolling.

export const SEED_TESTIMONIALS = [
  {
    id: "t-001",
    text: "The whole room stopped what they were doing and crowded the griddle. My kid is seven and she still talks about it.",
    authorName: "Megan R.",
    context: "7th birthday party, St. Louis",
    tier: "booker",
    createdAt: "2026-02-14",
  },
  {
    id: "t-002",
    text: "We've had live food on the show a hundred times. Nobody flips pancakes like this guy.",
    authorName: "Today Show producer",
    context: "NBC",
    tier: "press",
    createdAt: "2024-05-08",
  },
  {
    id: "t-003",
    text: "I cried when I got mine. It was my grandma's face, in batter, and now I have it forever.",
    authorName: "Alex D.",
    context: "Wedding guest, Wash U chapel",
    tier: "guest",
    createdAt: "2025-09-21",
  },
  {
    id: "t-004",
    text: "Booked Dan for our all-hands retreat expecting a cool novelty. Got a keynote moment. People are still sending me the videos.",
    authorName: "Priya K.",
    context: "Head of People, Square",
    tier: "booker",
    createdAt: "2025-11-02",
  },
  {
    id: "t-005",
    text: "It's genuinely one of those what-am-I-looking-at experiences. Then you eat the art and you want to cry.",
    authorName: "Disney D23 attendee",
    context: "D23 Expo",
    tier: "guest",
    createdAt: "2024-08-12",
  },
  {
    id: "t-006",
    text: "My dad never posts on Instagram. He posted the pancake Dan made of his dog. Twice.",
    authorName: "Jen M.",
    context: "70th birthday, Forest Park",
    tier: "booker",
    createdAt: "2025-06-18",
  },
  {
    id: "t-007",
    text: "The line was out the door and not a single person complained. They were all just watching him paint.",
    authorName: "Vendor coordinator",
    context: "Tower Grove Farmers Market",
    tier: "booker",
    createdAt: "2025-07-05",
  },
  {
    id: "t-008",
    text: "I didn't know a pancake could be sentimental. Mine has a yellow jacket on it because my husband wore one the night we met.",
    authorName: "Claire P.",
    context: "Engagement party guest",
    tier: "guest",
    createdAt: "2025-10-10",
  },
  {
    id: "t-009",
    text: "Hell's Kitchen has had some wild talent through our doors. Dan's the one I'd actually book for my own party.",
    authorName: "Hell's Kitchen crew",
    context: "Fox",
    tier: "press",
    createdAt: "2023-11-14",
  },
  {
    id: "t-010",
    text: "Watched my four-year-old sit perfectly still for fifteen minutes. That alone was worth the whole booking.",
    authorName: "Marcus O.",
    context: "Preschool family day",
    tier: "booker",
    createdAt: "2026-01-25",
  },
];

// Helper: stable sort + optional tier weighting (press > booker > guest when
// equal newness). Marquee never shows a perfectly-sorted set — sprinkled so
// each pass feels different.
export function orderedTestimonials(list = SEED_TESTIMONIALS) {
  const TIER_WEIGHT = { press: 3, booker: 2, guest: 1 };
  return [...list].sort((a, b) => {
    const tw = (TIER_WEIGHT[b.tier] || 0) - (TIER_WEIGHT[a.tier] || 0);
    if (tw !== 0) return tw;
    return (tsMs(b.createdAt) - tsMs(a.createdAt));
  });
}

function tsMs(v) {
  if (!v) return 0;
  if (typeof v === "string") return Date.parse(v) || 0;
  if (typeof v?.toMillis === "function") return v.toMillis();
  if (v instanceof Date) return v.getTime();
  return 0;
}
